import {
  FieldBuilder,
  MENU_CATEGORY_KEY,
  MENU_NAME_SUFFIX,
  MENU_SUBCATEGORY_KEY,
  MenuCategories,
  MenuSubcategories,
} from '@zendra/shared';

FieldBuilder.setNamespace('Geographic');

export const GISREGISTERINCONSISTENCYONLYINGIS_FIELDS = [
  FieldBuilder.text('name', 'Entity.GisRegisterInconsistency.Name').readOnly().build(),
];

export const GISREGISTERINCONSISTENCY_PERMISSION = 'PlanningGeography.Registers';

export const GISREGISTERINCONSISTENCYONLYINGIS_CONFIG = {
  entityName: 'GisRegisterInconsistencyOnlyInGis',
  localizationKey: 'Geographic::Entity.GisRegisterInconsistency.OnlyInGis',
  fields: GISREGISTERINCONSISTENCYONLYINGIS_FIELDS,
  permission: GISREGISTERINCONSISTENCY_PERMISSION,
  showInMenu: false,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Planning + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.QueriesPlanning + MENU_NAME_SUFFIX,
};
